module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем историю звонков..."
    }
  }) : (!_vm.order.clientPhone) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n    В данном заказе не задан телефон клиента, поэтому система не может загрузить звонки. Пожалуйста укажите номер телефона клиента, отредактировав заказ\n")]) : (_vm.items && _vm.items.length > 0) ? _c('div', [_vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 text-muted small"
    }, [_vm._v(_vm._s(item.date) + " в " + _vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "col-2 text-muted small"
    }, [(item.virtualNumber) ? [(item.virtualNumber) ? _c('span', [_vm._v(_vm._s(item.virtualNumber.number))]) : _vm._e(), _vm._v(" "), (item.virtualNumber && item.virtualNumber.city) ? _c('span', [_c('br'), _vm._v(_vm._s(item.virtualNumber.city.name))]) : _vm._e(), _vm._v(" "), (item.virtualNumber) ? _c('span', [_c('br'), _vm._v(_vm._s(item.virtualNumber.site))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(item.internalNumber) ? [_vm._v("\n                Ответил: " + _vm._s(item.internalNumber.number) + "\n                "), _vm._l((item.internalNumber.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [(_vm.currentUser.isAdmin) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))]) : [_vm._v(_vm._s(user.fullname))]], 2)
    })] : [_c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("\n                Не отвечен\n            ")])]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-5 text-muted small"
    }, [(item.internalNumber) ? [(item.records) ? _vm._l((item.records), function(record) {
      return _c('audio', {
        ref: "player",
        refInFor: true,
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": record.url
        }
      }), _vm._v("\n                        Ваш браузер не поддрживает воспроизведение аудио записей\n                    ")])
    }) : (_vm.loadingRecords === item.pbxCallId) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": "Загружаем записи..."
      }
    }) : _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadRecords(item.pbxCallId, index)
        }
      }
    }, [_vm._v("Загрузить запись")])] : [_vm._v("Запись разговора отсутсвует, т.к. звонок не был отвечен")]], 2)])
  }), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 2) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n    Входящие звонки по данному заказу к сожалению не найдены.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-bc983552"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderCallHistory.vue
// module id = 1065
// module chunks = 1